"use client";

import Link from "next/link";
import clsx from "clsx";
import { captureEvent } from "@/helpers/analytics";

const G2_REVIEW_CTA_URL = "https://www.g2.com/products/dash0/review_modalities/new";

export default function G2ReviewCtaButton({ className }: { className?: string }) {
  return (
    <Link
      href={G2_REVIEW_CTA_URL}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => captureEvent("g2_review_cta_click")}
      className={clsx(
        "justify-center relative shrink-0 rounded h-10 items-center text-center py-4 min-h-10 px-5 group font-medium transition-colors duration-200 flex whitespace-nowrap bg-white text-[#111111] hover:bg-grey-200",
        className
      )}
    >
      Leave a review
    </Link>
  );
}
